export const statusList = [
    {value : 10, label : "Pending"},
    {value : 20, label : "Callback"},
    {value : 30, label : "Postponed"},
    {value : 40, label : "Confirmed"},
    {value : 100, label : "Cancelled"},
]